import { render, staticRenderFns } from "./CalendarioReuniao.vue?vue&type=template&id=8b7bd19e"
import script from "./CalendarioReuniao.vue?vue&type=script&lang=js"
export * from "./CalendarioReuniao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports